export enum SkillPlaybackType {
  Apostle = 'apostles',
  Planet = 'avatars'
}
